module.exports = __webpack_public_path__ + "static/spinner@2x.88a5938225302fe1bf9e24a67ba0b100.gif";